import {HorribleHeroesReelSymbol} from "./HorribleHeroesReelSymbol";
import {SymbolStateTransition} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";

export class HorribleHerosScatterWildymbol extends HorribleHeroesReelSymbol {
    protected static globesXWPos: { [symHeight: number]: number [] } = {
        148: [54, 49],
        147: [54, 49],
        117.6: [55, 37],
        98: [56, 29],
        84: [57, 19],
        73.5: [57, 19]
    };
    protected _symTop: PIXI.Sprite;
    protected _symBottom: PIXI.Sprite;
    protected _symLeft: PIXI.Sprite;
    protected _symRight: PIXI.Sprite;
    protected _symWGlobes: PIXI.Sprite;
    protected W2: PIXI.Sprite;

    public addWinFire(): void {
        super.addWinFire();
        this._winFireAnimation.tint = 0x008d24;
    }

    public updateFrame(symHeight: number): void {
        if (this._symTop) {
            this._symTop.y = -symHeight / 2 + this._symTop.height / 2;
            this._symBottom.y = symHeight / 2 - this._symBottom.height / 2 + 2;
        }

        if (this.symName == "W" && symHeight < 147) {
            this._symWGlobes.scale.set(this.symHeight / 147);
            this._symWGlobes.x = this.symWidth / 2 - this._symWGlobes.width / 2;
            this._symWGlobes.y = this.symHeight / 2 - this._symWGlobes.height / 2;
            this.showHideFrameParts(true);
            this.W2.visible = false;
        }
        if (this.symName === "S" && symHeight < 147) {
            this.showHideFrameParts(true);
            this._symImage.alpha = 1;
            this.addChild(this._symImage);
        }
        if (this.symName == "S") {
            // this._symGlobes.x = HorribleHerosScatterWildymbol.globesXPos[symHeight];
        }
        if (this.symName == "W") {
            this._symWGlobes.position.set(HorribleHerosScatterWildymbol.globesXWPos[symHeight][0], HorribleHerosScatterWildymbol.globesXWPos[symHeight][1]);
        }
    }

    public adjustSize(symbolH: number, symId: number, duration: number = 0.17): TimelineLite {
        this.resetSymMask();
        this.drawSymMask();
        //#571
        const tl = new TimelineLite();
        const startPos = 0;
        const previousHeight = 147;
        const symTop = -symbolH / 2 + this._symTop.height / 2;
        const symBottom = symbolH / 2 - this._symBottom.height / 2 + 2;
        if (this.W2) {
            this.W2.alpha = 0;
        }
        if (this._symTop) {
            tl.to(this._symTop, duration, {y: symTop}, startPos);
            tl.to(this._symBottom, duration, {y: symBottom}, startPos);

        }
        if (this._symWGlobes) {
            if (this.symWidth) {
                const globesX = this.symWidth / 2 - this._symWGlobes.width / 2;
                const globesY = symbolH / 2 - this._symWGlobes.height / 2;
                this._symWGlobes.scale.set(this.symHeight / 147);
                tl.to(this._symWGlobes, duration, {x: globesX}, startPos);
                tl.to(this._symWGlobes, duration, {y: globesY}, startPos);
                this._symImage.alpha = 1;
                this.showHideFrameParts(true);
            }
        }
        if (this._symMask) {
            tl.to(this._symMask!.scale, duration, {y: symbolH / previousHeight}, startPos);
        }

        if (this._bg) {
            tl.to(this._bg.scale, duration, {y: symbolH / previousHeight}, startPos);
        }
        if (this._symImage) {
            tl.to(this._symImage.scale, duration, {x: symbolH / previousHeight, y: symbolH / previousHeight}, startPos);
        }
        tl.to(this, duration, {
            y: ((symId) * symbolH) + (symbolH / 2)
        }, startPos);

        return tl;
    }

    public drawSymMask(): void {
        if (this.symHeight < 255) {
            this._symMask = new PIXI.Graphics();
            this._symMask.beginFill(0xFF0000, 1);
            this._symMask.drawRect(-GameConfig.instance.SYMBOL_WIDTH / 2, -this.symHeight / 2, GameConfig.instance.SYMBOL_WIDTH + 20, this.symHeight);
            this.addChild(this._symMask);
            this.mask = this._symMask;
            this._symMask!.name = "mask";
        }
    }

    protected resetSymMask(): void {
        if (this._symMask) {
            this.removeChild(this._symMask!);
            this._symMask = null;
        }
    }

    protected initAnimations(): void {
        if (["S", "W"].indexOf(this.symName) > -1) {
            if (!this._bg) {
                this._bg = this.createEmptySprite(this.symName + "_bg");
                this._bg.anchor.set(0.5, 0.5);
                this._bg.name = "bg";
                this.addChild(this._bg);
                this._symImage = this.createEmptySprite(this.symName);
                if (this.symName == "W") {
                    this.W2 = this.createEmptySprite("W2");
                }

                this.addChild(this._symImage);
            }

            if (!this._symRight) {
                this._symLeft = this.createEmptySprite(this.symName + "_left");
                this._symLeft.x = -this.width / 2 + this._symLeft.width / 2;
                this._symRight = this.createEmptySprite(this.symName + "_right");
                this._symRight.x = this.width / 2 - this._symRight.width / 2;
            }

            if (!this._symTop) {
                this._symTop = this.createEmptySprite(this.symName + "_top", 0.5);
                this._symTop.y = -this.symHeight / 2 + this._symTop.height / 2;
            }

            if (!this._symBottom) {
                this._symBottom = this.createEmptySprite(this.symName + "_bottom", 0.5);
                this._symBottom.y = this.symHeight / 2 - this._symBottom.height / 2;
            }
            if (this.symName == "S") {
                this._symRight.x = 67;
                this._symLeft.x = -66;
                this._symBottom.y = 67;
                this._symTop.y = -68;
            }
            //donot change sequence
            if (this.symName === "S") {
                this.addChild(this._symImage);
                this.showHideFrameParts(true);
            }
            //donot change sequence
            if (!this._symWGlobes && this.symName == "W") {
                this._symWGlobes = this.createEmptySprite(this.symName + "_globes", 0.5);
                this._symWGlobes.x = this.width / 2 - this._symWGlobes.width / 2;
                this._symWGlobes.y = this.symHeight / 2 - this._symWGlobes.height / 2;
                this.addChild(this.W2);
            }
        }
    }

    protected addNewStateAnimation(timeline: TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number): void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if (this._winFireAnimation) {
            this._winFireAnimation.hide();
            this._winFireAnimation.stopLoop();
        }
        let scale: number = MathHelper.roundToDecimals(this.symHeight / 148, 2);

        if (newState.state.keyword === HorribleHeroesGameConfig.instance.SYMBOL_STATES.normal.keyword) {
            this.glowDimAllParts(0xffffff);
        }
        if (newState.state.keyword === HorribleHeroesGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            timeline.add(() => {
                this.glowDimAllParts(0x555555);
            }, delay);
        }
        if (newState.state.keyword === HorribleHeroesGameConfig.instance.SYMBOL_STATES.win.keyword) {
            if (this.symName == "W") {
                if (!this._winFireAnimation) {
                    this.addWinFire();
                }
                const scale: number = MathHelper.roundToDecimals(this.symHeight / 147, 2);
                this._winFireAnimation.scale.set(1, scale);
                this.addChild(this._winFireAnimation);
            }
            timeline.add(() => {
                if (this.symName == "W") {
                    this._winFireAnimation.tint = 0x008d24;
                    this._winFireAnimation.alpha = 1;
                    this._winFireAnimation.blendMode = PIXI.BLEND_MODES.ADD;
                    this._winFireAnimation.getAnimationAutoShowHide(true, true);
                    this.glowDimAllParts(0xffffff);
                }
            }, delay);
        }
        stateAnimation.scale.set(scale, scale);
        this._symImage.scale.set(scale, scale);
        this._bg.scale.set(1, scale);
    }

    private showHideFrameParts(isVisible: boolean): void {
        this._symTop.visible = isVisible;
        this._symBottom.visible = isVisible;
        this._symLeft.visible = isVisible;
        this._symRight.visible = isVisible;
        if (this.symName === "W") {
            this._symWGlobes.visible = isVisible;
        }
    }

    private glowDimAllParts(tintColor: number): void {
        this._bg.tint = tintColor;
        this._symTop.tint = tintColor;
        this._symBottom.tint = tintColor;
        this._symLeft.tint = tintColor;
        this._symRight.tint = tintColor;
        this._symImage.tint = tintColor;
        if (this.symName === "W") {
            this._symWGlobes.tint = tintColor;
        }
    }
}